import { Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

import { Loading } from '../../components/common/Loading/Loading';
import { useDiscount } from '../../hooks/useDiscount';
import { ChargingProgress } from '../Station/components/ChargingProgress/ChargingProgress';
import { useTranslation } from 'react-i18next';
import { StyledGreenSpan } from '../../components/common/StyledGreenSpan/StyledGreenSpan';
import { BackButton } from '../../components/common/Button/BackButton/BackButton';

export const LoyaltyPage = () => {
  const [loading, setLoading] = useState<boolean>(true);

  const { currentUserDiscountRange, discountRanges } = useDiscount();
  const { t } = useTranslation();

  useEffect(() => {
    if (discountRanges) {
      setLoading(false);
    }
  }, [currentUserDiscountRange, discountRanges]);

  if (loading) return <Loading />;

  return (
    <Stack
      sx={{
        padding: '14px 22px',
        maxWidth: '400px',
        width: '100%',
        gap: '35px',
      }}
    >
      <BackButton skipReloadPage />
      <Stack sx={{ gap: '35px' }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          sx={{ gap: '21px' }}
          alignItems="flex-start"
        >
          <ChargingProgress
            value={currentUserDiscountRange?.completionPercentage || 0}
            size={50}
          />
          <Stack sx={{ gap: '10px' }}>
            <Typography variant="body2" color="common.white">
              {t('loyaltyPage.levelText')}{' '}
              {currentUserDiscountRange?.levelIndex} -{' '}
              <StyledGreenSpan>
                {currentUserDiscountRange?.discountLabel}
              </StyledGreenSpan>
            </Typography>
            <Typography variant="body2" color="common.white">
              {t('loyaltyPage.yourDiscountAmountText')}{' '}
              {currentUserDiscountRange?.discount}%.
              {t('loyaltyPage.movingToTheNextLevelText')}{' '}
              {
                discountRanges?.[currentUserDiscountRange?.levelIndex as number]
                  ?.discount
              }
              %, {t('loyaltyPage.refuelInTheAmountOfText')}{' '}
              {currentUserDiscountRange?.max} {t('orderPage.energyUnit')}
            </Typography>
          </Stack>
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="body2" color="common.white">
            {t('loyaltyPage.toTheNextLevel')}:
          </Typography>
          <Typography variant="body2" color="green.main">
            {currentUserDiscountRange?.nextLevel} {t('orderPage.energyUnit')}
          </Typography>
        </Stack>
      </Stack>
      <Stack
        sx={{
          display: 'grid',
          gridTemplateColumns: `repeat(4, 1fr)`,
          gap: '21px',
        }}
      >
        {discountRanges?.map((range) => (
          <Stack
            direction="column"
            sx={{ gap: '7px' }}
            textAlign="center"
            key={range.discountLabel}
          >
            <Typography
              variant="body2"
              color={range.current ? 'common.white' : 'gray.50'}
            >
              {range.discountLabel}
            </Typography>
            <ChargingProgress
              value={range.completed ? 100 : 0}
              size={50}
              differentText={range.discount}
            />
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};
